import React, { useMemo, useState } from 'react'
import { FaBook, FaAddressCard, FaUserAlt, FaThumbsUp, FaThumbsDown, FaRegIdCard } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, StepperItem, TextField, FileFieldIcon, TextFieldIcon, Panel, ModalComponent } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { handleFileChange } from '../_utils'
import { CircularProgress } from '@material-ui/core'
import { Formik } from 'formik'

const steps = [
  "Pending", "Actioned"
]

const ActionField = ( record ) => {
    return (
      <div onClick={async () => {
        await localStorage.setItem( "link", "client_audit_feedback" )
        await localStorage.setItem( "applicationId", record.value )
        return window.location.reload()
      } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
        {`View`}
      </div>
    )
}

const ProgressField = record => {
    console.log( '%',record.value )
    return (
      <div className="flex w-full items-center justify-center">
        <ProgressBar value={record.value}/>
        <div className="text-xs mx-2">
            {`${record.value}%`}
        </div>
      </div>
    )
}

export default function MyAudits( ) {
  const ApplicationColumns = useMemo( () => [
    {
      Header: "#",
      accessor: "recordId"
    },
    {
      Header: "S.No",
      accessor: "sno"
    },
    {
      Header: "Business Trading Name",
      accessor: "applicant"
    },
    {
      Header: "Date Applied",
      accessor: "date"
    },
    {
      Header: "Annual Income",
      accessor: "annual_income"
    },
    {
      Header: "Application Progress",
      accessor: "progress",
      Cell: ProgressField
    },
    {
      Header: "Action",
      accessor: "id",
      Cell: ActionField
    }
  ] )
  
  const [ records, setRecords ] = useState( [] )
  const [ loading, setLoading ] = useState( true )
  const [ tag, setTag ] = useState( "Pending" )
  const [itcoApplicationsLevel, setItcoApplicationsLevel] = useState('0'); 
  const [ levelRecords, setLevelRecords ] = useState( [] )
  const [ showUploadNewDoc, setShowUploadNewDoc ] = useState( false )
  const [ files, setFiles ] = useState( [] )
  const [ circularLoading, setCircularLoading ] = React.useState( false )
  const [ uploadedExpProof, setUploadedExpProof ] = useState( {} )
  const [selectedFiles, setSelectedFiles] = useState([]);

  React.useEffect( () => {
    if( loading ) {
        fetchApplications()
        fetchAllDocuments()
    }
  },[ loading, itcoApplicationsLevel ])

  const toggleFileSelection = (id) => {
    setSelectedFiles(prev =>
      prev.includes(id) ? prev.filter(fileId => fileId !== id) : [...prev, id]
    );
  };
  
  const toggleSelectAll = () => {
    if (selectedFiles.length === files.length) {
      setSelectedFiles([]);
    } else {
      setSelectedFiles(files.map(file => file.id));
    }
  };

  const deleteSelectedFiles = async () => {
    if (!window.confirm("Are you sure you want to delete the selected files?")) return;
  
    try {
      const response = await Axios.post(process.env.REACT_APP_API_URL + `/api/auth/delete_multiple_documents`, {
        file_ids: selectedFiles
      });
  
      if (response.data) {
        alert(response.data.message);
        window.location.reload();
      }
    } catch (error) {
      console.error(error);
      alert("Failed to delete selected files.");
    }
  };

  const fetchAllDocuments = async () => {
    let applicationId = localStorage.getItem( "applicationId" )
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getApplicationFiles/${applicationId}` )
      if( response.data ){
        setFiles( response.data?.data )
      }
    } catch (error) {}
  }

  const fetchApplications = async () => {
    try {
      const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/itcoapplication` ) 
      if( response.data ) {
        const results = response.data.map( ( result, index ) => {
          return {
            recordId: `${index+1}`,
            progress: result.progress,
            stage: result.stage,
            applicant: result.trading_name,
            email_address: result.created_by,
            date: moment( result.created_at ).format( "DD MMM, YYYY" ),
            annual_income: result.annual_turnover,
            scheduled_action: result.scheduled_action,
            scheduled_date: result.scheduled_date,
            client_reaction_to_audit: result.client_reaction_to_audit,
            id: result.id
          }
        } ).filter( record => { 
          return parseInt( record.stage ) === 5  && record.scheduled_action?.toUpperCase() === "COMPLETED"  && record.email_address?.toLowerCase() === localStorage.getItem( "username" )?.toLowerCase() && record.client_reaction_to_audit === null
      } )

      //update the state
      setRecords( results )
      //setLoading( false )
      }
    } catch (error) {
      alert( "Server error occured." )
      //setLoading( false )
    }
  }

  const handleNewFileUpload = async ( values ) => {
    await setCircularLoading( true )
  
    let description = values?.description
  
    const data = new FormData()
  
    data.append( "file", uploadedExpProof.document )
    //data.append( "name", uploadedExpProof.name )
    data.append( "name", description )
    data.append( "title", description )
    data.append( "type", uploadedExpProof.type )
    data.append( "size", uploadedExpProof.size )
    data.append( "application_id", localStorage.getItem( "applicationId" ) )
    data.append( "description", description )
    data.append( "created_by", localStorage.getItem( "email" ) )
  
    try {
      const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/addITDocuments`, data, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
      } )
      if( response.data ) {
        await setShowUploadNewDoc( false )
        alert( response.data.message )
        //console.log(response.data)
        return window.location.reload()
        await setCircularLoading( false )
      }
    } catch (error) {
        console.log( error )
    }
  }
  
  const handleFileBlur = (evt) => {
    let savedFile = { 
      file: uploadedExpProof.document, 
      title: uploadedExpProof.name, 
      size: uploadedExpProof.size, 
      tag: uploadedExpProof.tag, 
      type: uploadedExpProof.type, 
    }
  
    let data = Object.assign( {}, savedFile )
  
    //dispatch(  setExperienceProofFiles( {experienceProofFiles: [ ...state.experienceProofFiles, data ] }) )
  }
  
  const handleFile = ( evt, tag ) => {
    handleFileChange( evt, tag, (response, file ) => {
      if(file.size > 6128180){
        alert("Please make sure that the file size doesn't exceed 5 MBs")
      } else{
        setUploadedExpProof( {
          document: response,
          name: file.name,
          size: file.size,
          tag: tag,
          type: file.type
        })
      }
    })
    //console.log(uploadedExpProof.document)
  }

  const previewFile = async (e) => {
    let file_id = e.target.id

    try {
      const email = btoa(localStorage.getItem( "email" )); // Base64 encode
      const url = process.env.REACT_APP_API_URL+`/api/auth/get_file_details/${file_id}/${email}`
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
      if (newWindow) newWindow.opener = null
    } catch (error) {}
  }

  const DeleteFile = async (e) => {
    let file_id = e.target.id

    if (window.confirm("Are you sure you want to delete this file ?") == true) {
      try {
        const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/delete_application_document`, {file_id: file_id})
        if( response.data ) {
          alert( response.data.message )
          return window.location.reload()
        }
      } catch (error) {
        console.log( error )
      }
    }
  }


  if( localStorage.getItem( "link" ) === "add_client_document"){

    return (
      <Wrapper>
        <div className="flex flex-col h-full">
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`My Documents`}
            </div>
            <div className="flex flex-col justify-center w-3/4 bg-white">
              <table className="w-full border">
                <thead className="text-xs bg-gray-200 font-bold p-2">
                    <th className="p-2">#</th>
                    <th>Name</th>
                    <th>Size</th>
                    <th>Action</th>
                    <th className="p-2">
                      <input type="checkbox" onChange={toggleSelectAll} />
                    </th>
                    <th>Date Created</th>
                </thead>
                <tbody>
                    {files?.map( ( item, index ) => {
                        return (
                            <tr className="text-xs p-2 text-center">
                                <td className="p-2">{`${index+1}`}</td>
                                {/* <td>{item.description !== null ? item.description.replaceAll("_", " ") : "" }</td> */}
                                <td>{item.name}</td>
                                <td>{item.size}</td>
                                <td>
                                  {/* <a className="bg-red-500 text-xs text-white px-2 py-1" href={item.file} download={item.name}>Download</a> */}
                                  <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.id} onClick={previewFile}>View File</a>
                                  <a className="bg-red-800 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.id} onClick={DeleteFile}>Delete</a>
                                </td>
                                <td className="p-2">
                                  <input
                                    type="checkbox"
                                    checked={selectedFiles.includes(item.id)}
                                    onChange={() => toggleFileSelection(item.id)}
                                  />
                                </td>
                                <td>{moment( item.created_at ).format("DD MMM, YYYY HH:mm:ss")}</td>
                            </tr>
                        )
                    } )}
                </tbody>
              </table>
              <div className="flex justify-between">
                <button onClick={async () => {
                  setShowUploadNewDoc(true)
                } } className="pr-10 bg-amber-600 text-white p-1 m-2 rounded-sm">Upload new document</button>

                <button
                  disabled={selectedFiles.length === 0}
                  onClick={deleteSelectedFiles}
                  className="bg-red-700 text-white p-1 m-2 rounded-sm"
                >
                  Delete Selected Files
                </button>
              </div>
            </div>
          </div>
        </div>
        <ModalComponent title={`Upload new document`} open={showUploadNewDoc}>
          <Panel label="Upload New Document">
            <div className="flex flex-col items-start justify-center px-5 py-2">
              <Formik initialValues={{
                  actioned_by: localStorage.getItem( "username" )
                  }} onSubmit={handleNewFileUpload}>
                  { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                      return (
                          <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                              <div className="w-full grid grid-rows-2 gap-1">
                                <TextFieldIcon 
                                  name="description"
                                  handleChange={evt => {
                                      handleChange(evt)
                                  }}
                                  handleBlur={handleBlur}
                                  value={values.description}
                                  iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                  label="File Description"
                                  required={ true }
                                  question="File Description" />
                                      
                                <FileFieldIcon
                                  noPadding
                                  name="client_document"
                                  handleBlur={evt => {
                                    handleBlur(evt)
                                    handleFileBlur( evt )
                                  }}
                                  handleChange={evt => {
                                    handleChange(evt)
                                    handleFile( evt, "client_document" )
                                  }}
                                  iconComponent={<FaUserAlt color={`#666`} />}
                                  label="Document (Should be PDF)"
                                  question="Document (Should be PDF)" 
                                  required={true}
                                  tooltip=""
                                  tooltipExplanation="Attach any document that was missed by client E.g Contract, LPO, Certificate etc" 
                                />
                              </div>

                              {circularLoading ? (
                                  <div className="flex items-center justify-center">
                                      <CircularProgress size={24} color="primary" />
                                  </div>
                              ):
                              ( 
                                  <button type="submit" className="text-xs bg-purple-700 text-white px-2 py-1">
                                      {`Submit`}
                                  </button>
                              )}
                          </form>
                      )
                  }  }
              </Formik>
            </div>
          </Panel>

          <div className="flex flex-col items-center justify-center">
            <button onClick={async () => {
              setShowUploadNewDoc(false)
              } } className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
              Close
            </button>
          </div>
        </ModalComponent>
      </Wrapper>
    )
  } else{

    return (
      <Wrapper>
        <div className="flex flex-col h-full">
          <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
            <div className="px-5 py-2 text-sm bg-white">
              {`My Audit Reports`}
            </div>
            <div className="flex flex-col justify-center w-full bg-white">
              
                <Table 
                  rightButton={false}
                  rightBtnCallback={ () => {}}
                  rightButtonLabel={null}
                  label="Application Details"
                  columns={ApplicationColumns}
                  data={records}
                  hidePagination={false}
                  exportToExcel={() => {}}
                  exportToCSV={() => {}}
                />
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }
}